import {
  COUNTRY_CODES,
  countryPreset,
  esPaisConocido,
  etiquetaPais,
  paisesOrdenados,
} from '@alexiarest/shared';

type Opcion = { value: string; label: string };

/**
 * Opciones del selector de pais: los mercados habituales arriba y despues
 * los 240 paises por orden alfabetico. Antes solo habia siete y «Otro pais»,
 * y un cliente italiano se quedaba sin pais y en dolares (7 sep 2026).
 *
 * Sin banderas en las etiquetas: las pruebas e2e eligen por el nombre.
 */
const HABITUALES = new Set<string>(COUNTRY_CODES);
const OPCIONES_PAIS: Opcion[] = [
  ...COUNTRY_CODES.map((code) => ({ value: code, label: countryPreset(code).label })),
  ...paisesOrdenados()
    .filter((pais) => !HABITUALES.has(pais.code))
    .map((pais) => ({ value: pais.code, label: etiquetaPais(pais.code) })),
];

/**
 * Opciones para un buscador cuyo valor actual es `actual`. Un tenant antiguo
 * con «OTHER» ve una opcion «Sin indicar» arriba para que el buscador no
 * salte solo a Espana: asi se le puede pedir que elija de verdad.
 */
export function countryOptionsFor(actual: string | undefined): Opcion[] {
  if (actual === undefined || esPaisConocido(actual)) return OPCIONES_PAIS;
  return [{ value: actual, label: 'Sin indicar' }, ...OPCIONES_PAIS];
}

/**
 * Opciones del pais fiscal. Es la misma lista entera: hasta el 9 sep 2026
 * eran solo los 36 paises con regla de IVA conocida, y un cliente de El
 * Salvador buscaba su pais y no salia (Pol). El regimen no lo decide esta
 * lista, lo decide `regimenIvaDe`, que ya sabe que fuera de la UE es «no
 * sujeto»; recortar aqui solo dejaba fuera a clientes de verdad.
 *
 * Sin «Sin indicar»: en facturacion el pais vacio no es una opcion que se
 * elija, es un dato que falta. Un valor antiguo que no este en la tabla si
 * se enseña, para poder cambiarlo.
 */
export function taxCountryOptions(actual: string | undefined): Opcion[] {
  const codigo = (actual ?? '').trim();
  if (codigo === '' || esPaisConocido(codigo)) return OPCIONES_PAIS;
  return [{ value: codigo, label: etiquetaPais(codigo) }, ...OPCIONES_PAIS];
}
